import * as React from "react";
const SvgCrop169 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 6H3v12h18V6zm-2 10H5V8h14v8z",
  fill: "currentColor"
}));
export default SvgCrop169;